import React from 'react';
import { Typography } from 'seagull';
import styles from "./MapContactsModal.module.scss";
import { contactModel } from "../../../../models";
import { getContactMapStatus } from "./MapContactsRow";
import orderBy from 'lodash/orderBy';
import sortBy from 'lodash/sortBy';
export let ContentState = /*#__PURE__*/function (ContentState) {
  ContentState["Loading"] = "loading";
  ContentState["Empty"] = "empty";
  ContentState["Error"] = "error";
  ContentState["Valid"] = "valid";
  return ContentState;
}({});
export let FooterState = /*#__PURE__*/function (FooterState) {
  FooterState["Valid"] = "valid";
  FooterState["Invalid"] = "invalid";
  return FooterState;
}({});
export const columnDefs = [{
  width: 400
},
// Anchor contacts
{
  width: 400
},
// QuickBooks Online customers
{
  width: 260
} // Status
];
export const headerItems = [{
  value: /*#__PURE__*/React.createElement("div", {
    className: styles.columnHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2"
  }, "Anchor contact"))
}, {
  value: /*#__PURE__*/React.createElement("div", {
    className: styles.columnHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2"
  }, "QuickBooks Online customer"))
}, {
  value: 'Status'
}];
export let QboCustomersDropdownOptionType = /*#__PURE__*/function (QboCustomersDropdownOptionType) {
  QboCustomersDropdownOptionType["CreateNew"] = "createNew";
  QboCustomersDropdownOptionType["Existing"] = "existing";
  return QboCustomersDropdownOptionType;
}({});
export let FailureReasons = /*#__PURE__*/function (FailureReasons) {
  FailureReasons["General"] = "general";
  FailureReasons["DuplicateMapping"] = "duplicateMapping";
  FailureReasons["DuplicateNew"] = "duplicateNew";
  return FailureReasons;
}({});
export function getModalState(contacts, qboCustomers) {
  if (contacts.loading || qboCustomers.loading) {
    return {
      content: ContentState.Loading,
      footer: FooterState.Invalid
    };
  } else if (contacts.error || qboCustomers.error) {
    return {
      content: ContentState.Error,
      footer: FooterState.Invalid
    };
  } else if (contacts.data && qboCustomers.data) {
    return contacts.data.length === 0 ? {
      content: ContentState.Empty,
      footer: FooterState.Invalid
    } : {
      content: ContentState.Valid,
      footer: FooterState.Valid
    };
  } else {
    return {
      content: ContentState.Loading,
      footer: FooterState.Invalid
    };
  }
}
export function getNumMappedContacts(contacts) {
  return contacts.filter(c => !!c.integratedId).length;
}
export function getRelevantSortedContacts(contacts, contactIds) {
  if (!contacts) {
    return [];
  }
  const filtered = contacts.filter(c => (!contactIds.length || contactIds.includes(c.id)) && !c.isSample);
  const sortProperties = ['firstName', 'lastName', 'companyName'];
  const orderedByName = orderBy(filtered, sortProperties, ['asc', 'asc', 'asc']);
  return sortBy(orderedByName, c => !!c.integratedId);
}
export function applyFilters(contacts, search, contactMappingStatusFilter) {
  const searchFiltered = contacts.filter(c => applySearch(search, c));
  const contactMappingStatusFilterOptions = getContactMappingStatusFilterOptions(searchFiltered);
  const filteredAnchorContacts = searchFiltered.filter(c => applyContactMappingStatusFilter(contactMappingStatusFilter, c));
  return {
    filteredAnchorContacts,
    contactMappingStatusFilterOptions
  };
}
function getContactMappingStatusFilterOptions(contacts) {
  return contacts.reduce((acc, contact) => {
    const status = getContactMapStatus(contact);
    const existingStatusEntry = acc.findIndex(option => option.value === status);
    if (existingStatusEntry >= 0) {
      acc[existingStatusEntry].counter = (acc[existingStatusEntry].counter || 0) + 1;
    } else {
      acc.push({
        value: status,
        counter: 1,
        label: status === 'mapped' ? 'Yes' : 'No'
      });
    }
    return acc;
  }, []);
}
function applySearch(search, contact) {
  const normalizedSearch = search ? search.trim().toLowerCase() : search;
  const companyName = contactModel.companyName(contact).toLowerCase();
  const firstName = contactModel.firstName(contact).toLowerCase();
  const lastName = contactModel.lastName(contact).toLowerCase();
  const email = contactModel.email(contact).toLowerCase();
  return !normalizedSearch || "".concat(companyName, " ").concat(firstName, " ").concat(lastName, " ").concat(email).includes(normalizedSearch);
}
function applyContactMappingStatusFilter(filter, contact) {
  return filter.length === 0 || filter.some(status => status === 'mapped' && contactModel.integratedId(contact) != null || status === 'notMapped' && contactModel.integratedId(contact) == null);
}